export enum BottomSheetContentEnum {
  Closed,
  ContactSupport,
  CSATFormResolved,
}
